import { gql } from '@apollo/client';

export const FETCH_DATA_IMPORTER_TEMPLATES = gql`
    query fetchDataImporterTemplates($dataImporterFilter: DataImporterFilter) {
        lookup {
            dataImporters(filter: $dataImporterFilter) {
                type
                displayName
                isRestricted
                showHistory
                historicalJobType
                helpUrl
                template
            }
        }
    }
`;
